import { create } from "zustand";
const DEFAULT_MANUAL = {
    aggression: 50,
    targetPriority: "lowest_hp",
    focusFire: false,
    preset: "balanced",
};
export const useStore = create((set) => ({
    player: null,
    squad: null,
    lastMatch: null,
    onboarded: false,
    brainType: "preset",
    manualStrategy: DEFAULT_MANUAL,
    battlePhase: "idle",
    battleResult: null,
    battleFrameIdx: 0,
    pendingPlay: null,
    setPendingPlay: (pendingPlay) => set({ pendingPlay }),
    inboxUnread: 0,
    setInboxUnread: (inboxUnread) => set({ inboxUnread }),
    setPlayer: (player) => set({ player, onboarded: true }),
    setSquad: (squad) => set({ squad }),
    setLastMatch: (lastMatch) => set({ lastMatch }),
    setOnboarded: (onboarded) => set({ onboarded }),
    setBrainType: (brainType) => set({ brainType }),
    setManualStrategy: (patch) => set((state) => ({ manualStrategy: { ...state.manualStrategy, ...patch } })),
    updateBalances: (delta) => set((state) => {
        if (!state.player)
            return {};
        return {
            player: {
                ...state.player,
                credits: state.player.credits + (delta.credits ?? 0),
                energy: state.player.energy + (delta.energy ?? 0),
                rating: state.player.rating + (delta.rating ?? 0),
                rankPoints: state.player.rankPoints + (delta.rankPoints ?? 0),
            },
        };
    }),
    setBattlePhase: (battlePhase) => set({ battlePhase }),
    setBattleResult: (battleResult) => set({ battleResult }),
    setBattleFrameIdx: (battleFrameIdx) => set({ battleFrameIdx }),
    clearBattle: () => set({ battlePhase: "idle", battleResult: null, battleFrameIdx: 0 }),
}));
